import React, { useState, useEffect } from "react";
import Pending from "../../../assets/Icon/pending.png";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import PostAllDataModule from "../../../Components/Reuseable/PostAllDataModule";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const PendingPost = () => {
  const [event_data, setEvents] = useState([]);
  const [pending, setPending] = useState([]);
  const [buffer, setBuffer] = useState(true);

  //Fetch Pending Post
  useEffect(() => {
    axios.get(`/api/star/simple_post/count`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setPending(res.data.pending);
      }
    });
  }, []);

  //   Fetch Pending Post
  useEffect(() => {
    axios.get(`/api/star/simple_post/pending`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.post);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Pending Post" image={Pending} count={pending} />

      {buffer ? (
        <LoaderPost />
      ) : (
        <PostAllDataModule data={event_data} urlLink={`/superstar/post`} />
      )}
    </>
  );
};

export default PendingPost;
